export const WEDDING_GIFT_CONFIRMATION_URL =
  "https://script.google.com/macros/s/AKfycbwhVIScHUT3VP5pezm2xrsqtoC6VNkhkhVHUlIR9ly_664bDzfh-cyFeRkHiPOkzi4g/exec";

export const ACCOUNT_INFO = [
  { id: 1, name: "Adila Salma Khansa", number: "0374431893", bank: "BCA" },
  { id: 2, name: "Rafdian Ramadhan", number: "0348390618", bank: "BNI" },
];
